/* eslint-disable prefer-const */
// Pre-existing pattern: hosts are declared with `let` and assigned separately below.
import { SyncEnv } from 'src/app/shared/models';

const version = '3.1.38';
const upgradePromoBannerUrl = 'https://www10.sync.com/template-includes/cp-upgrade-promo.php';
const currenthost = `https://${window.location.host}`;

let viewhost,
  previewhost1,
  previewhost2,
  previewhost3,
  webhost,
  linkhost,
  publinkdatahost,
  publinkdatahostpro,
  wopihost,
  logohost,
  commenthost,
  multiadminhost,
  cphost,
  featureHost,
  eventreaderhost,
  chargebeeSite,
  chargebeePublishableKey,
  hubspotHost,
  cookiedomain,
  imageconversionhost,
  ordershost,
  extapihost,
  blendToken,
  unauthBlendToken,
  blendHost,
  wakeHost;

if (window.location.hostname === 'us.sync.com' || window.location.hostname === 'ln6.sync.com') {
  ((viewhost = 'https://viewer2.sync.com'), (previewhost1 = 'https://preview1.sync.com'));
  previewhost2 = 'https://preview2.sync.com';
  previewhost3 = 'https://preview3.sync.com';
  ((webhost = 'https://www10.sync.com/'), (linkhost = 'https://ln6.sync.com/'));

  publinkdatahost = 'https://ln.syncusercontent.com';
  publinkdatahostpro = 'https://ln.syncusercontentpro.com';
  wopihost = 'https://us-wopi.sync.com';
  logohost = 'https://us-img.sync.com/download/';
  commenthost = 'https://us-comments.sync.com/comments';
  multiadminhost = 'https://us-multiadmin.sync.com/';
  cphost = 'https://us.sync.com';
  featureHost = 'https://us-features.sync.com/';
  eventreaderhost = 'https://us-events.sync.com';
  chargebeeSite = 'synccom';
  chargebeePublishableKey = 'live_LuhdKmji9PUajk2eab8GR4LgIiBDAADu';
  hubspotHost = 'https://www.sync.com';
  cookiedomain = '.sync.com';
  imageconversionhost = 'https://us-imgconv.sync.com';
  ordershost = 'https://us-orders.sync.com'; //deprecated
  extapihost = 'https://us-extapi.sync.com';
  blendToken = '1d6f07777377255f5e4a4ec8405a72d8';
  unauthBlendToken = '191f1e7f9c56bd3b2a320125fc06edda';
  blendHost = 'https://us-blend.sync.com/blend';
  wakeHost = 'https://us-wake.sync.com/sub';
} else {
  cphost = 'https://cp.sync.com';
  ((viewhost = 'https://viewer2.sync.com'), (previewhost1 = 'https://preview1.sync.com'));
  previewhost2 = 'https://preview2.sync.com';
  previewhost3 = 'https://preview3.sync.com';
  ((webhost = 'https://www10.sync.com/'), (linkhost = 'https://ln5.sync.com/'));

  publinkdatahost = 'https://ln.syncusercontent.com';
  publinkdatahostpro = 'https://ln.syncusercontentpro.com';
  wopihost = 'https://wopi.sync.com';
  logohost = 'https://img.sync.com/download/';
  commenthost = 'https://comments.sync.com/comments';
  multiadminhost = 'https://multiadmin.sync.com/';
  cphost = 'https://cp.sync.com';
  featureHost = 'https://features.sync.com/';
  eventreaderhost = 'https://events.sync.com';
  chargebeeSite = 'synccom';
  chargebeePublishableKey = 'live_LuhdKmji9PUajk2eab8GR4LgIiBDAADu';
  hubspotHost = 'https://www.sync.com';
  cookiedomain = '.sync.com';
  imageconversionhost = 'https://imgconv.sync.com';
  ordershost = 'https://orders.sync.com'; //deprecated
  extapihost = 'https://extapi.sync.com';
  blendToken = '1d6f07777377255f5e4a4ec8405a72d8';
  unauthBlendToken = '191f1e7f9c56bd3b2a320125fc06edda';
  blendHost = 'https://blend.sync.com/blend';
  wakeHost = 'https://wake.sync.com/sub';
}

const cpRegionHostmap = {
  'ca-central': 'https://cp.sync.com',
  GLOBAL: 'https://cp.sync.com',
  FORCEGLOBAL: 'https://cp.sync.com',
  'us-central': 'https://us.sync.com',
  US: 'https://us.sync.com',
  FORCEUS: 'https://us.sync.com',
};

const linkRegionHostmap = {
  'ca-central': 'https://ln5.sync.com',
  GLOBAL: 'https://ln5.sync.com',
  FORCEGLOBAL: 'https://ln5.sync.com',
  'us-central': 'https://ln6.sync.com',
  US: 'https://ln6.sync.com',
  FORCEUS: 'https://ln6.sync.com',
};

const wopiRegionHostmap = {
  'ca-central': 'https://wopi.sync.com',
  GLOBAL: 'https://wopi.sync.com',
  FORCEGLOBAL: 'https://wopi.sync.com',
  'us-central': 'https://us-wopi.sync.com',
  US: 'https://us-wopi.sync.com',
  FORCEUS: 'https://us-wopi.sync.com',
};

export const environment: SyncEnv = {
  production: true,
  version,
  versionPollInterval: 300000,

  jslibpath: '/workers/',

  apihosts: ['/api/v1/'],

  wopihost,
  currenthost,

  cookiedomain,
  cookiesecure: true,

  // host names
  linkhost,
  publinkdatahost,
  publinkdatahostpro,
  previewhost1,
  previewhost2,
  previewhost3,
  viewhost,
  webhost,
  ordershost,

  imageconversionhost, // we still need this for logo preview in custom branding dialog
  logohost, // use this followed by image cachekey to fetch logo for display
  commenthost,
  multiadminhost,
  cphost,
  extapihost,
  blendToken,
  unauthBlendToken,
  blendHost,
  featureHost,
  wakeHost,
  upgradePromoBannerUrl,
  eventreaderhost,
  isDev: false,
  chargebeeSite,
  chargebeePublishableKey,
  hubspotHost,
  hubspotPortalId: '47231785',
  // Sentry SDK sampling rates — see SentryService.initSentry
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.1,
  turnstileSiteKeyRegionMap: {
    'ca-central': '0x4AAAAAADTzp1NJSX_liJ2e',
    'us-central': '0x4AAAAAADTzsNiaggm5QPXo',
    GLOBAL: '0x4AAAAAADTzp1NJSX_liJ2e',
    FORCEGLOBAL: '0x4AAAAAADTzp1NJSX_liJ2e',
    US: '0x4AAAAAADTzsNiaggm5QPXo',
    FORCEUS: '0x4AAAAAADTzsNiaggm5QPXo',
  },
  turnstileEnabled: true,
  cpRegionHostmap,
  linkRegionHostmap,
  wopiRegionHostmap,
};

export const extModules = [];
